import { Component, Input, OnInit } from '@angular/core';
import { UIRouter } from '@uirouter/core';
import { ShareButtonsService, DataToShareInterface } from './shareButtons.service';
import { DownloadService } from '../download/download.service';
import { AppState } from '../../app.service';

export interface SocialNetworkInterface {
  name: string,
  show: boolean
}

@Component({
  selector: 'jb-share-buttons',
  templateUrl: './shareButtons.component.html',
  styleUrls: [
    './shareButtons.component.scss'
  ]
})
export class ShareButtonsComponent implements OnInit {
  public socialNetworks: Array<SocialNetworkInterface> = [
    {
      name: 'facebook',
      show: true
    },
    {
      name: 'twitter',
      show: true
    },
    {
      name: 'linkedIn',
      show: true
    },
    {
      name: 'whatsApp',
      show: true
    },
    {
      name: 'iMessage',
      show: true
    },
    {
      name: 'navigatorShare',
      show: true
    }
  ];
  private socialNetworksObjectKeys = Object.keys(this.socialNetworks);
  public buttonsLayout: string;
  private tooltipTimeout: any;
  private navigator: any = window.navigator;

  @Input() public layout: number;
  @Input() public excludeSocialNetworks: Array<string>;
  @Input() public dataToShare: DataToShareInterface;

  constructor(
    private router: UIRouter,
    private shareButtonsService: ShareButtonsService,
    private downloadService: DownloadService,
    private appState: AppState
  ) { }

  public ngOnInit() {
    if (typeof this.layout === 'undefined') {
      this.buttonsLayout = '_icon-buttons';
    } else {
      switch (this.layout) {
        case 1:
          this.buttonsLayout = '_icon-buttons';

          break;
        case 2:
          this.buttonsLayout = '_single-button';

          break;
        case 3:
          this.buttonsLayout = '_icon-buttons _modal-buttons';

          break;
        default:
          this.buttonsLayout = '_icon-buttons';

          break;
      }
    }

    if (typeof this.excludeSocialNetworks !== 'undefined') {
      if (this.excludeSocialNetworks.length > 0) {
        this.socialNetworksObjectKeys.forEach((key, index) => {
          if (this.excludeSocialNetworks.indexOf(this.socialNetworks[index].name) !== -1) {
            this.socialNetworks[index].show = false;
          }
        });
      }
    }
  }

  public share(socialNetwork: string) {
    if (typeof this.dataToShare !== 'undefined') {
      if (socialNetwork === 'NavigatorShare') {
        this.navigator.share({
          title: this.dataToShare.title,
          text: this.dataToShare.copy,
          url: this.dataToShare.sharingLink
        }).then(() => {
          console.log('Thanks for sharing!');
        })
        .catch(console.error);
      } else {
        this.dataToShare.socialNetwork = socialNetwork;

        if (this.layout !== 3) {
          this.dataToShare.sharingLink = `${this.dataToShare.linkToShare}n/${this.isMobileDevice().any() ? 'mobile' : 'desktop'}/n`;
          this.dataToShare.linkToShare = `${this.dataToShare.linkToShare}n/${this.isMobileDevice().any() ? 'mobile' : 'desktop'}`;
          this.shareButtonsService.toggleShareModal(this.dataToShare, true);
        } else {
          this.shareButtonsService.processSharing(this.dataToShare);
        }
      }
    }
  }

  public openShareModal() {
    if (this.dataToShare.buttonHtmlLink) {
      this.dataToShare.sharingLink = `https://pk7napwge5.execute-api.eu-central-1.amazonaws.com/stg/html/button/${this.dataToShare.buttonHtmlLink}/${this.isMobileDevice().any() ? 'mobile' : 'desktop'}/n`;
      this.dataToShare.buttonHtmlLink += `/${this.isMobileDevice().any() ? 'mobile' : 'desktop'}`;
    }

    this.shareButtonsService.toggleShareModal(this.dataToShare, true);
  }

  public toggleTooltip(evt: Object) {
    let tooltip =  evt['currentTarget'].querySelector('span');

    if (evt['type'] === 'mouseenter') {
      this.tooltipTimeout = setTimeout(() => {
        if (tooltip.classList.contains('_show-tooltip') === false) {
          tooltip.classList.add('_show-tooltip');
        }
      }, 1000);
    } else {
      clearTimeout(this.tooltipTimeout);

      if (tooltip.classList.contains('_show-tooltip') !== false) {
        tooltip.classList.remove('_show-tooltip');
      }
    }
  }

  public copyToClipboard(link: string) {
    const linkInput = (document.getElementById('shareLinkInput') as HTMLInputElement);
    linkInput.select();
    linkInput.setSelectionRange(0, 99999);
    document.execCommand('copy');
  }

  public isMobileDevice() {
    const isMobile = {
      Android: () => {
        return navigator.userAgent.match(/Android/i);
      },
      BlackBerry: () => {
        return navigator.userAgent.match(/BlackBerry/i);
      },
      iOS: () => {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i) ||
              navigator.userAgent.match(/Safari/i) && navigator.maxTouchPoints > 1;
      },
      Opera: () => {
        return navigator.userAgent.match(/Opera Mini/i);
      },
      Windows: () => {
        return navigator.userAgent.match(/IEMobile/i);
      },
      any: () => {
        return (
          isMobile.Android() ||
          isMobile.BlackBerry() ||
          isMobile.iOS() ||
          isMobile.Opera() ||
          isMobile.Windows() ||
          navigator.userAgent.match(/Safari/i) && navigator.maxTouchPoints > 1
        );
      }
    };

    return isMobile;
  }

  public canNavigatorShare() {
    if (this.navigator.canShare) {
      return true;
    } else {
      return false;
    }
  }

  public download() {
    this.downloadService.triggerDownload(this.dataToShare.image);
  }
}



// WEBPACK FOOTER //
// ./src/app/global/shareButtons/shareButtons.component.ts